import AuthService from '../services/AuthService';

export const BackEndHelper = {
    request
};

function request(method, url, data, json = true) {
    let auth = new AuthService();
    var qs = "";

    const fetchHeaders = new Headers();
    fetchHeaders.append("Accept-Charset", "utf-8");
    fetchHeaders.append("Accept", "application/json");

    if (auth.loggedIn()) {
        fetchHeaders.append("Authorization", "Bearer " + auth.getToken());
    }

    if (json) {
        fetchHeaders.append("content-type", "application/json");
    }

    const requestOptions = {
        method: method,
        headers: fetchHeaders,
        body: null
    };
    if (method === "GET") {
        let query = "";
        if (data !== undefined) {
          if (Object.keys(data).length > 0) {
            query = Object.keys(data)
              .map((k) => {
                if (Object.prototype.toString.call(data[k]) === "[object Array]") {
                  let stringArray = "";
                  data[k].forEach((element) => {
                    stringArray += encodeURIComponent(k) + "=" + encodeURIComponent(element) + "&";
                  });
                  return stringArray.length > 0 ? stringArray.slice(0, -1) : "";
                } else {
                  return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
                }
              })
              .join("&");
          }
          qs = "?" + query;
        }
      } else {
        if (json) {
          requestOptions.body = JSON.stringify(data);
        } else {
          requestOptions.body = data;
        }
      }

    url = url + qs;

    return fetch(url, requestOptions)
        .then(handleResponse).catch(error => handleError(error, url, requestOptions));
}

function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.ok) {
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                resolve();
            }
        } 
        else if (response.ok === false && response.status >= 400) {
          if (response.status === 401) {
              window.location.href = `/user/login?returnurl=${encodeURIComponent(window.location.href)}`;
              return Promise.reject('Unauthorized');
          }    
          else {
            response.text().then(text => reject(text));
          }
        }
    });
}

function handleError(error, url, requestOptions, retryCount = 0) {
  if (error === 'No autorizado' && retryCount < 1) {
    return fetch(url, requestOptions)
        .then(response => handleResponse(response, url, requestOptions))
        .catch(err => handleError(err, url, requestOptions, retryCount + 1));
  }
  return Promise.reject(error && error.message);
}